// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1AsrW","alert":"SettungsInbox_alert__2RdGb"};